import React, {useState, useEffect, useContext} from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import "./AccountDetails.css";
import PlainModal from '../../HtmlElements/PlainModal';
import { COMPANY_LOGO_BASE_URL, NEWS_IMAGE_BASE_URL } from '../../../config/apiConfig';
import { ensureProtocol, numberWithCommas, stripUrl, truncateDescription } from '../../../services/commonService';
import { useUser } from '../../../context/UserContext';
import { AccountListContext } from '../../../context/AccountListContext';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import RenderHtmlFormattedText from '../../HtmlElements/RenderHtmlFormattedText';
import { useSelector } from 'react-redux';
import CompanyPrimaryInfoSkeleton from '../skeletons/companyPrimaryInfoSkeleton/companyPrimaryInfoSkeleton';
import { handleAccountPlanDownloadBtn } from '../uiUtils/customApi';

export default function CompanyPrimaryInfo() {


  // const accountPlanConfig = {
  //   MNM_MOOG : "/account_plans/Moog_Account_Plan.pdf",
  //   MNM_PANASONIC:"/account_plans/Panasonic_Account_Plan.pdf",
  //   NIIT_PFIZER:"/excels/NIIT_Pfizer_AccountPlan.xlsx",
  //   NIIT_BOEING:"/excels/NIIT_Boeing_AccountPlan.xlsx"
  // }
  
  useAuth();
  const [account, setAccount] = useState([]);
  const [company_banner_path, setCompanyBannerpath] = useState('')
  const [overview_text, setOverviewText] = useState('');
  // const [successMessage, setSuccessMessage] = useState('');
  // const [bookmarkAccount, setBookmarkAccount] = useState(false);
  const [showDescriptionModal, setShowModal] = useState(false);
  const [isBannerLoading, setBannerLoading] = useState(true); // Loading state for banner
  const [isLogoLoading, setLogoLoading] = useState(true); // Loading state for logo

  const { account_info, account_details,account_info_loading,account_details_loading } = useSelector(state=>state.accountsReducer);

  const {my_favourites} = useUser();
  const { favouriteAccounts } = useContext(AccountListContext);
  // const { accountId, accountName, clientName } = useParams();
  const modalShowDescription = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const [isAccountPlan,setIsAccountPlan]=useState(0)
 
  
  useEffect(() => {
    if (account_info && account_details) {

      setAccount(account_info);

      let account_code = account_info?.db_details?.account_code ? account_info?.db_details?.account_code : '';
      let account_name = account_info?.db_details?.account_name ? account_info?.db_details?.account_name : '';

      let urlParams = {
        "img_index": 0,
        "companies": account_info.name ? {[account_code]: account_name} : '',
        'size': '500',
      };

      let img_base_url = NEWS_IMAGE_BASE_URL;
      let encodedParams = encodeURIComponent(JSON.stringify(urlParams));

      let company_banner_path = img_base_url + encodedParams;
      setCompanyBannerpath(company_banner_path)

      let my_favourites_acc = my_favourites?.account || [];
      const favouriteAccountList = favouriteAccounts || [];
      const favouriteNamesSet_1 = favouriteAccountList.map(fav => fav.name);
      const favouriteNamesSet_2 = my_favourites_acc.map(fav => fav.account_name);
      const favouriteNamesSetArr = [...favouriteNamesSet_1, ...favouriteNamesSet_2];
      // const favouriteNamesSet = new Set(favouriteNamesSetArr);

      // const isFavourite = favouriteNamesSet.has(account.name) ? 1 : 0

      setOverviewText(account_info?.business_description ? account_info.business_description : account_details?.overview || "");
      // setBookmarkAccount(isFavourite)
      setIsAccountPlan(account_info?.db_details?.["is_account_plan"])
    }
  }, [account_info_loading,account_details_loading, account, favouriteAccounts, my_favourites]);

  useEffect(() => {
    let successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      // setSuccessMessage(successMessage);
      sessionStorage.removeItem("successMessage");

      // setTimeout(() => {
      //   setSuccessMessage("");
      // }, 2000);
    }
  }, []); // Add an empty dependency array to run only once
// console.log("accountName, clientName",accountName, clientName)

  if ((!account_info_loading &&  !account_details_loading) && (!account_details || !account_info?.name)) {
    return null
  }
  return (
    <>
      <div className="generic-take-space-child mb-2">
        <div className="custom_card_block p-0">
          <div className="company_overview_wrapper" >
            {(account_info_loading || account_details_loading) &&
            !account_info?.name ? (
              <CompanyPrimaryInfoSkeleton />
            ) : (
              <>
                <div className="top_img">
                  {company_banner_path && (
                    <>
                      {isBannerLoading && (
                        <div className="baseSkeleton img-banner-container"></div>
                      )}{" "}
                      {/* Loading skeleton for banner */}
                      <img
                        key={`account_img_banner_${account_info?.name}`}
                        src={company_banner_path}
                        className={`image_block ${
                          isBannerLoading ? "hidden" : ""
                        }`}
                        alt=""
                        aria-label="comapny-banner-img"
                        onLoad={() => setBannerLoading(false)} // Set loading state to false when image loads
                      />
                    </>
                  )}
                  {/* <div className="save_name_round">
                    <span className="bookmark_company">
                      <i
                        onClick={() => toggleFavourite(account?.db_details?.id)}
                        className={`fa ${
                          bookmarkAccount ? "fa-bookmark" : "fa-bookmark-o"
                        }`}
                        aria-hidden="true"
                        title="Add to Favourites"
                      ></i>
                    </span>
                  </div> */}
                  <div className="company_name_round">
                    {account_info?.name ? (
                      <>
                        {isLogoLoading && (
                          <div className="baseSkeleton img-logo-banner-container"></div>
                        )}{" "}
                        {/* Loading skeleton for logo */}
                        <img
                          key={`account_img_${account_info?.name}`}
                          src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                            account_info?.name
                          )}`}
                          alt=""
                          aria-label="comapny logo img"
                          className={`company_logo ${
                            isLogoLoading ? "hidden" : ""
                          }`}
                          onLoad={() => setLogoLoading(false)} // Set loading state to false when image loads
                        />
                      </>
                    ) : (
                      <><div className="baseSkeleton img-logo-banner-container"></div></>
                    ) }
                  </div>
                </div>
                <div className="compnay_info_wrapper">
                  <h5 className="company_name">
                    {account?.display_name
                      ? account?.display_name
                      : account.name}
                  </h5>

                  <div>
                    <div className="company_info">
                      <RenderHtmlFormattedText htmlContent={overview_text} />
                    </div>
                    {overview_text && (
                      <Link
                        onClick={modalShowDescription}
                        className="read-more-button"
                      >
                        <span className="show_more">
                          <i
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </Link>
                    )}
                  </div>
                </div>

                <div className="compnay_subinfo_wrapper">
                  <ul className="company_list">
                    {account?.incorporation_date && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>Founded Year:</b> <br />{" "}
                              {account.incorporation_date}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back blue_icon">
                            <img
                              src="/img/icons/overview/rocket.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </p>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>Founded Year:</b> <br />{" "}
                              {account.incorporation_date}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            {account.incorporation_date}
                          </p>
                        </OverlayTrigger>
                      </li>
                    )}

                    {account?.trbc_business_sector_name && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Business Sector:</b> <br />
                              {account.trbc_business_sector_name}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back brown_icon">
                            <img
                              src="/img/icons/overview/setting.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </p>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Business Sector:</b> <br />
                              {account.trbc_business_sector_name}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            {truncateDescription(
                              account?.trbc_business_sector_name,
                              15
                            ).isTruncated
                              ? truncateDescription(
                                  account?.trbc_business_sector_name,
                                  15
                                ).truncated_info + "..."
                              : account?.trbc_business_sector_name}
                          </p>
                        </OverlayTrigger>
                      </li>
                    )}

                    {account?.trbc_industry_name && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Industry :</b> <br />
                              {account?.trbc_industry_name}
                            </Tooltip>
                          }
                        >
                          <div className="icon_with_back green_icon">
                            <img
                              src="/img/icons/overview/building.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </div>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Industry :</b> <br />
                              {account?.trbc_industry_name}
                            </Tooltip>
                          }
                        >
                          <div className="info_company">
                            {" "}
                            {truncateDescription(
                              account?.trbc_industry_name,
                              15
                            ).isTruncated
                              ? truncateDescription(
                                  account?.trbc_industry_name,
                                  15
                                ).truncated_info + "..."
                              : account?.trbc_industry_name}{" "}
                          </div>
                        </OverlayTrigger>
                      </li>
                    )}

                    {account?.employees && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Employees: </b> <br />
                              {numberWithCommas(account?.employees)}{" "}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back magenta_icon">
                            <img
                              src="/img/icons/overview/Union.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </p>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Employees: </b> <br />
                              {numberWithCommas(account?.employees)}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            {numberWithCommas(account.employees)}
                          </p>
                        </OverlayTrigger>
                      </li>
                    )}

                    {account?.headquarter && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Headquarters (Country):</b> <br />{" "}
                              {account?.headquarter}{" "}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back blue_icon">
                            <img
                              src="/img/icons/overview/marker.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </p>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Headquarters (Country):</b> <br />{" "}
                              {account?.headquarter}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            {" "}
                            {account?.headquarter}
                          </p>
                        </OverlayTrigger>
                      </li>
                    )}

                    {account?.organization_website && (
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>Organization Website :</b>{" "}
                              {stripUrl(account?.organization_website)}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back grey_icon">
                            <img
                              src="/img/icons/overview/globe.png"
                              className="img_icons_overview"
                              alt=""
                            />
                          </p>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Organization Website :</b>{" "}
                              {stripUrl(account?.organization_website)}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            <a
                              href={ensureProtocol(
                                account?.organization_website
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="compnay_link"
                            >
                              {stripUrl(account?.organization_website)}
                            </a>
                          </p>
                        </OverlayTrigger>
                      </li>
                    )}
                    <li className="company_sublist">
                      {" "}
                      {isAccountPlan && <a
                       
                        className='agreementSubmitBtn'
                        style={{backgroundColor:"lightgray",
                          maxHeight:"2vh",
                          fontSize:"0.8rem",
                          color:"#164e63",
                          display:"flex",
                          justifyContent:"center",
                          alignItems:"center",
                          textDecoration:"none",
                          boxShadow:"none"
                        }}

                        onClick={()=>handleAccountPlanDownloadBtn(account_info?.db_details?.account_code,account_info?.db_details?.client_code )}
                      >
                        Account Plan
                      </a>}
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>

          {showDescriptionModal && (
            <PlainModal
              title="Overview"
              text={overview_text}
              handleClose={handleClose}
              html_text_div_container_class="account_overview_view_more_text"
            />
          )}
        </div>
      </div>
    </>
  );
}
